import { WHATSAPP_FETCH_AUDIENCELIST, WHATSAPP_FETCH_BULK_MESSGAE_LSIT } from '../actions/actiontypes';
export default function (state = {}, action) {
    switch (action.type) {
        case WHATSAPP_FETCH_AUDIENCELIST: {
            return { ...state, audienceList: action.payload };
        }
        case WHATSAPP_FETCH_BULK_MESSGAE_LSIT: {
            return { ...state, bulkMessageList: action.payload };
        }
        default:
            return state;
    }
}
